import { Component, Inject } from "@angular/core";
import { NgForm } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DeviceDetectorService } from "ngx-device-detector";
import { AbstractBiditComponent } from "../../../shared/controls/abstract.bidit.component";
import { FileUpload } from "../../../shared/models/file.upload.interface";
import { CustomerService } from "../../services/customer.service";

export interface ImportDialogData { }

@Component({
  selector: 'app-import-dialog',
  templateUrl: './import.dialog.html',
  styleUrls: ['./import.dialog.scss']
})
export class ImportDialog extends AbstractBiditComponent {
  fileBytes?: string;
  importFile?: any;

  constructor(
    protected customerService: CustomerService,
    deviceDetectorService: DeviceDetectorService,
    public dialogRef: MatDialogRef<ImportDialog>,
    @Inject(MAT_DIALOG_DATA) public data: ImportDialogData) {
    super(deviceDetectorService);
  }

  importCustomer(importForm: NgForm) {
    this.errors = '';

    if (this.fileBytes == undefined) {
      this.errors = 'File is required';
      return;
    }

    this.isRequesting = true;

    // Set File Information
    let file: FileUpload = {
      fileName: this.importFile.name,
      fileSize: this.importFile.size,
      fileType: this.importFile.type,
      lastModifiedTime: this.importFile.lastModified,
      lastModifiedDate: this.importFile.lastModifiedDate,
    } as FileUpload;

    file.fileAsBase64 = this.fileBytes;

      // POST to server
      this.customerService.uploadCustomerImport(file)
        .subscribe({
          next: (resp) => {
            this.errors = "Upload complete";
            this.dialogRef.close(true);
          },
          error: (error: string) => {
            this.isRequesting = false;
            alert($localize`Error - Unable to import file.  Check sample file for required column layout.  Only .csv and .xlsx format files are supported.`);
          }
        });
    

  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
